var rex_php_tags = new RegExp("<\\?php(?:[\\n\\r]|.)+?\\?>(?!\"|'')", "gim");
var rex_script_tags = new RegExp("<script(?:[\\n\\r]|.)+?\\/script>", "gim");
var rex_comments_tags = new RegExp("<!--(?:[\\n\\r]|.)+?-->", "gim");

// Strips php contents /!\ THIS DELETES PHP TAGS AND EVERYTHING IN BETWEEN /!\
function stripPhpContents(str) {
    return str.replace(rex_php_tags, "");
}

// Strips js contents /!\ THIS DELETES SCRIPT TAGS AND EVERYTHING IN BETWEEN /!\
function stripJSContents(str) {
    return str.replace(rex_script_tags, "");
}

// Strips html comments /!\ THIS DELETES COMMENTS TAGS AND EVERYTHING IN BETWEEN /!\
function stripHTMLComments(str) {
    return str.replace(rex_comments_tags, "");
}

function stripCombo(str) {
    var output = stripHTMLComments(str);

    output = stripJSContents(output);
    output = stripPhpContents(output);

    return output;
}

function loadProduct(new_id, type, page) {
    const form = this;
    let activeForm = form;
    const old_id = form.getAttribute('data-product-id');
    const color_id = form.getAttribute('data-product-color');

    const sze_id = form.getAttribute('data-product-size');
    const qte_itm = 1;
    const is_model = form.getAttribute('data-hdn-is-model');
    const isCategSuper = form.getAttribute('data-is-categ-super');
    const is_achat_express = form.hasAttribute('is-express');

    // In case we have color regroup products
    const isRegroupeRef = form.hasAttribute('is-regroup-ref');
    const regroupRefId = isRegroupeRef ? form.getAttribute('data-cpt') : '';
    const cpt_prod = regroupRefId !== '' ? (regroupRefId - 1) : '';
    document.body.style.overflow = '';

    const data = {
        produit_id: old_id,
        produit_principal: old_id,
        couleurProd: color_id,
        tailleProd: sze_id,
        qteProd: qte_itm,
        hdn_product_id: old_id,
        hdn_is_model: is_model,
        produit_id_new: new_id,
        type: type,
        type_page: (page !== undefined && page !== '') ? page : 'product',
        is_achat_express_v2: is_achat_express ? 1 : 0,
        isCategSuper : isCategSuper,
        cpt_prod: cpt_prod,
    };

    fetch(path_relative_root + 'ajax_get_product_regroup_ref.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
    })
    .then(response => response.json())
    .then(res => {
        if (res.success == 'ok') {
            let datas = res.datas;

            // add selected Item to Datalayer impressions
            if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && datas.dataLayerItem) {
                try {
                    let currentImpressions = JSON.parse(window. dl_v3_impressions || '[]');
                    currentImpressions.push(datas.dataLayerItem);
                    window.dl_v3_impressions = JSON.stringify(currentImpressions);
                } catch (e) {
                    console.error(e);
                }
            }

            // Parse HTML into a DIV-based DocumentFragment
            const tmp = document.createElement('div');
            tmp.innerHTML = stripCombo(datas.html_main);
            let $html_main = document.createDocumentFragment();
            $html_main.appendChild(tmp.firstChild);

            if (data.type_page == 'product') {
                if (is_achat_express) {
                    const refreshedForm = $html_main.querySelector('.product-infos-form');
                    form.closest('.item-product').replaceWith($html_main);
                    if (refreshedForm) {
                        activeForm = refreshedForm;
                    }
                } else {
                    document.querySelector('.main-content').innerHTML = datas.html_main;
                    displaySelectedColor();

                    // Product DOM is replaced here, so rebind Unify widgets on the new markup.
                    if (typeof initUnifyStoreAvailabilityWidget === 'function') {
                        initUnifyStoreAvailabilityWidget();
                    }
                    if (typeof initUnifyStockWidgetProductPage === 'function') {
                        initUnifyStockWidgetProductPage();
                    }
                    // Same for the Apple Pay express checkout button, whose container comes back empty.
                    if (typeof initApplePayExpressCheckout === 'function') {
                        initApplePayExpressCheckout();
                    }

                    const refreshedForm = document.querySelector('.product-main .product-infos-form');
                    if (refreshedForm) {
                        activeForm = refreshedForm;
                        document.dispatchEvent(new CustomEvent('loadProduct_complete', {
                            detail: {
                                form: refreshedForm
                            }
                        }));
                    }
                }
            }

            activeForm.querySelector('.product-add-cart-button').removeAttribute('is-processing');
            updateBtnAddCart('#' + activeForm.id);

            json_colisages = res.stock;
            let checkedColor;
            checkedColor = activeForm.querySelector('input[name="prod_color"]:checked');
            if (checkedColor) {
                setAvailableSizes.call(activeForm);
            }

            if (window.wShop && wShop.$refs && wShop.$refs.wAlertestockForm) {
                wShop.$refs.wAlertestockForm.reloadBloc += 1;
            }
        } else {
            alert('Erreur lors du chargement du produit');
        }
    })
    .catch(e => {
        console.error('parseJSON', e);
    })
    .finally(() => {
        setTimeout(function () {
            if (!is_achat_express) {
                initFpVisuals();
                syncThumbsHeight();

                if (document.querySelector('.recently-browsed-slider')) {
                    initRecentlyBrowsed();
                }
            }
            observeLazyImages();
        }, 0);

        if (
            (data.type_page == 'product' && !data.is_achat_express_v2) &&
            typeof getAvailableQuantity === 'function' &&
            typeof query_stock_in_cache === 'boolean' && query_stock_in_cache === true
        ) {
            getAvailableQuantity(activeForm);
            checkItemsStock(true);
        } else {
            checkItemsStock();
        }

        // Init sizes slider if present
        activeForm.querySelectorAll('.swiper').forEach(el => {
            new Swiper(el, {
                slidesPerView: 'auto',
                navigation: {
                    prevEl: '.prev-size',
                    nextEl: '.next-size',
                },
            });
        });
    });
}

function setAvailableSizes() {
    // this = form, passed through setAvailableSizes.call()
    const form = this;
    const produit_id = form.getAttribute('data-product-id');
    // const elem_id = document.querySelector('input[name="prod_color"]:checked').value;
    const elem_id = form.querySelector('input[name="prod_color"]:checked').value;
    var warehouse_only = 0;

    // Define the isGlobalEActive variable, if not defined
    isGlobalEActive = refreshIsGlobalEActive() ? true : false; 
    if (isGlobalEActive) {
        warehouse_only = 1;
    }

    let data = new URLSearchParams({ 'produit_id[]': produit_id, 'warehouse_only': warehouse_only });

    fetch(path_relative_root + 'ajax_get_colisages_states_by_color_size.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
    })
    .then(response => response.json())
    .then(res => {

        if (
            res.success &&
            res.result &&
            res.result[produit_id] !== undefined &&
            res.result[produit_id][elem_id] !== undefined
        ) {
            const btnAddCart = form.querySelector('.product-add-cart-button');
            const btnAlertStock = form.querySelector(".product-add-alert-button");
            const result = res.result[produit_id];
            const sizes_tab = result[elem_id];
            let size_box, is_disabled;
            let obj = $('.product-visuals');

            for (size_id in sizes_tab) {
                if (sizes_tab.hasOwnProperty(size_id)) {
                    size_box = form.querySelector('[name="prod_size"][value="' + size_id + '"]');

                    size_label = size_box.nextElementSibling;
                    is_disabled = !sizes_tab[size_id];

                    if (is_disabled) {
                        size_label.setAttribute("no-stock", "");
                        size_box.classList.add("disabled");

                        // Special case if single size and no stock
                        if (size_box.checked && (Object.entries(sizes_tab).length == 1)) {
                            btnAddCart.setAttribute('is-hidden', '');
                            btnAddCart.removeAttribute('is-processing');
                            removeAttributes(btnAlertStock, ['is-hidden', 'is-processing']);
                        }
                    } else {
                        size_label.removeAttribute("no-stock");
                        size_box.classList.remove("disabled");

                        // Special case if single size and available stock
                        if (size_box.checked && (Object.entries(sizes_tab).length == 1)) {
                            removeAttributes(btnAddCart, ['is-hidden', 'is-processing']);
                            btnAlertStock.setAttribute('is-hidden', '');
                            btnAlertStock.removeAttribute('is-processing');
                        }
                    }
                } else {
                    btnAddCart.setAttribute('is-hidden', '');
                    btnAddCart.removeAttribute('is-processing');
                    removeAttributes(btnAlertStock, ['is-hidden','is-processing']);
                }
            }
            let label2 = obj.find('.eclat.rect');
            if (label2.length > 0) {
                if (result.stock_quantite > 0) {
                    if (result.stock_quantite < 4) {
                        // eclat limite
                        obj.find('.limited_stock').removeClass('cache');
                    } else {
                        // eclat automatic
                        if (obj.find('.automatic').length > 0) {
                            obj.find('.automatic').removeClass('cache');
                        }
                    }
                } else {
                    // eclat no stock
                    obj.find('.no_stock').removeClass('cache');
                }
            }
        }

        updateBtnAddCart('#' + form.id);

        // Trigger item sliders load and remove modal-backdrop (from mobile color interaction)
        initializeItemSliders();
        if (document.querySelector('.modal-backdrop').hasAttribute('is-visible')) {
            toggleBackdrop(0);
        }

        // dataLayer product stock display updated Event
        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    'event': 'product_stock_display_updated',
                });
            }
        } catch (e) {
            console.error(e);
        }
    })
    .catch(e => {
        console.error("parseJSON", e);
    });
}

/**
 * Re-evaluates the Global-E context at call time instead of relying on the value
 * set once on window load : the Global-E script is loaded asynchronously, so
 * isGlobalEActive can still be 0 when the user interacts with the product form.
 * Also refreshes the global isGlobalEActive so the other consumers stay in sync.
 *
 * @returns {boolean} true if the current session is operated by Global-E
 */
function refreshIsGlobalEActive() {
    let isOperatedByGlobalE = false;

    if (
        typeof GEM_Services != "undefined" &&
        typeof GEM_Services.ConfigurationsService != "undefined" &&
        typeof GEM_Services.ConfigurationsService.Instance != "undefined" &&
        typeof GEM_Services.ConfigurationsService.Instance.UserLocalizeSettings != "undefined" &&
        typeof GEM_Services.ConfigurationsService.Instance.UserLocalizeSettings.IsOperatedByGlobalE != "undefined"
    ) {
        isOperatedByGlobalE = !!GEM_Services.ConfigurationsService.Instance.UserLocalizeSettings.IsOperatedByGlobalE;
    } else if (typeof GEP != 'undefined' && GEP.isOperatedByGlobale !== undefined && GEP.isOperatedByGlobale !== false) {
        isOperatedByGlobalE = !!GEP.isOperatedByGlobale;
    } else if (typeof isGlobalEActive != 'undefined') {
        // Global-E not ready yet : fall back on the value already resolved on load
        isOperatedByGlobalE = !!isGlobalEActive;
    }

    if (typeof isGlobalEActive != 'undefined') {
        isGlobalEActive = isOperatedByGlobalE;
    }

    return isOperatedByGlobalE;
}

/**
 * Fetches and updates the available quantity for a product based on selected color and size.
 * Disables unavailable sizes and updates the UI accordingly (showing/hiding add to cart or alert stock buttons).
 *
 * @async
 * @param {HTMLFormElement} form - The product form element containing product ID, color, and size inputs
 * @returns {Promise<boolean|void>} Returns true if stock is available, false if out of stock, or void if color/size not selected
 * @throws {Error} Throws an error if the API response is not OK or if the response JSON is invalid
 *
 * @description
 * - Validates that both color and size are selected
 * - Makes an AJAX request to fetch inventory data
 * - Updates size input disabled state and styling based on stock availability
 * - Handles button visibility (add to cart vs alert stock) considering MposV2 mode
 * - Triggers UI updates and handles mobile-specific alert stock modal behavior
 * - Updates the quantity input field (0 for out of stock, 1 for in stock)
 */
async function getAvailableQuantity(form) {
    const productId = form.getAttribute('data-product-id');
    const formId = "#" + form.id;
    const btnAddCart = form.querySelector('.product-add-cart-button');
    const btnAlertStock = form.querySelector('.product-add-alert-button');
    const formAlertStock = form.querySelector('.alert-stock-wrapper');
    const color_id = form.querySelector('input[name="prod_color"]:checked') ? form.querySelector('input[name="prod_color"]:checked').value : '';
    const size_id = form.querySelector('input[name="prod_size"]:checked') ? form.querySelector('input[name="prod_size"]:checked').value : '';
    const isExpress = form.hasAttribute('is-express');

    if (color_id == '' || size_id == '') {
        if (color_id == '') {
            console.warn('No color selected');
        }
        if (size_id == '') {
            console.warn('No size selected');
        }
        return;
    }

    let datas = {
        idprod: productId,
        idcouleur: color_id,
        idtaille: size_id,
        json: '1',
        // Le controleur attend la chaine 'true' (cf. AjaxController::ajaxListeQte)
        isGlobalEActive: refreshIsGlobalEActive() ? 'true' : 'false',
    };

    const response = await fetch(
        path_relative_root + 'ajax_liste_qte.php?' + new URLSearchParams(datas),
        {
            method: 'GET',
            credentials: 'same-origin'
        }
    );

    if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(`HTTP ${response.status} – ${response.statusText} – body: ${text.slice(0, 200)}`);
    }

    let res;
    try {
        res = await response.json();
    } catch (e) {
        const text = await response.text().catch(() => '');
        throw new Error(`Invalid JSON: ${e.message} – body: ${text.slice(0, 200)}`);
    }

    let inventoryData = res.inventory;
    let qteProdInput = document.getElementById("qteProd");
    
    if (!inventoryData.enableAddToCart) {
        // Disable the unavailable size
        const inputSize = form.querySelector(`#prod_size_${productId}_${size_id}`);
        inputSize?.classList.add('disabled');

        const labelSize = form.querySelector(`label[for="${inputSize?.id}"]`);
        labelSize?.setAttribute('no-stock', '');
        labelSize?.setAttribute('has-alert', '');

        // If we're in MposV2 mode, we let the Unify Stock Widget handle the button display
        if (typeof isMposV2 == 'undefined' || (typeof isMposV2 !== 'undefined' && !isMposV2)) {

            if (btnAlertStock) {
                btnAddCart.setAttribute('is-hidden', '');
                btnAlertStock.removeAttribute('is-hidden');
                formAlertStock.setAttribute('is-hidden', '');
                if (window.wShop && wShop.$refs && wShop.$refs.wAlertestockForm) {
                    wShop.$refs.wAlertestockForm.reloadBloc += 1;
                }

                // Close alert stock on mobile
                if (is_mobile) {
                    document.querySelector('.modal-backdrop').addEventListener('click', function () {
                        const el = form.querySelector('.alert-stock-wrapper')
                        const isVisible = el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
                        if (isVisible) {
                            reloadFromAlertStock(form.getAttribute('data-product-id'));
                        }
                    });

                    document.addEventListener('reloadAlertStock_end', function () {
                        toggleBackdrop(0);
                    });
                }
            } else {
                btnAddCart.removeAttribute('is-hidden');
                btnAlertStock.setAttribute('is-hidden', '');
                btnAlertStock.innerHTML = Translator.translate('size_is_not_available');
                formAlertStock.setAttribute('is-hidden', '');
                if (window.wShop && wShop.$refs && wShop.$refs.wAlertestockForm) {
                    wShop.$refs.wAlertestockForm.reloadBloc += 1;
                }
            }
        }

        btnAddCart.removeAttribute('is-processing');
        btnAlertStock.removeAttribute('is-processing');

        if (qteProdInput) qteProdInput.value = 0;

        setTimeout(function () {
            updateBtnAddCart(formId);
        }, 0);

        return false; // Stop here, no stock
    } else {

        // If we're in MposV2 mode, we let the Unify Stock Widget handle the button display
        if (typeof isMposV2 == 'undefined' || (typeof isMposV2 !== 'undefined' && !isMposV2)) {
            btnAlertStock.setAttribute('is-hidden', '');
            btnAddCart.removeAttribute('is-hidden');
            formAlertStock.setAttribute('is-hidden', '');
        }

        btnAddCart.removeAttribute('is-processing');
        btnAlertStock.removeAttribute('is-processing');
        if (window.wShop && wShop.$refs && wShop.$refs.wAlertestockForm) {
            wShop.$refs.wAlertestockForm.reloadBloc += 1;
        }

        if (qteProdInput) qteProdInput.value = 1;

        setTimeout(function () {
            updateBtnAddCart(formId);
        }, 0);

        return true; // Has stock
    }
}

function onItemColorChange(form) {
    const isRegroup = form.hasAttribute('is-regroup-ref');
    const btnAddCart = form.querySelector(".product-add-cart-button");
    const btnAlertStock = form.querySelector(".product-add-alert-button");
    const wrapperAlertStock = form.querySelector(".alert-stock-wrapper");

    // The refusal that is displayed is tied to the color that was submitted
    removeAddToBasketError(form);

    btnAddCart.setAttribute('is-processing', '');
    btnAlertStock.setAttribute('is-processing', '');
    form.setAttribute('data-product-id', form.querySelector('input[name="prod_color"]:checked').getAttribute("data-fk-product-id"));
    // form.setAttribute('data-product-id', form.querySelector('input[name="prod_color"]:checked').getAttribute("data-product-id"));
    form.setAttribute('data-product-color', this.value);

    setTimeout(function () {

        btnAddCart.setAttribute('data-product-color', this.value);
        btnAddCart.setAttribute('data-product-id', form.querySelector('input[name="prod_color"]:checked').getAttribute("data-fk-product-id"));
        wrapperAlertStock.setAttribute('data-alert-color', this.value);
        // Mobile interactions
        if (is_mobile && form.hasAttribute('is-express')) {
            form.querySelectorAll('.item-interaction-color').forEach(function (el) {
                el.removeAttribute('is-selected');
            });
            form.querySelector('#item-interaction-color-' + form.getAttribute('data-product-color')).setAttribute('is-selected', '');
        }

        if (isRegroup) {
            loadProduct.call(form, form.getAttribute('data-product-id'), 'couleur', '');
        } else {
            setAvailableSizes.call(form);
        }

        document.dispatchEvent(new CustomEvent('onItemColorChange_complete', {
            detail: {
                form: form
            }
        }));
    }, 0);
}

async function onItemSizeChange(form) {
    const btnAddCart = form.querySelector(".product-add-cart-button");
    const btnAddWishlist = form.querySelector(".item-wishlist");
    const btnAlertStock = form.querySelector(".product-add-alert-button");
    const wrapperAlertStock = form.querySelector(".alert-stock-wrapper");
    const isExpress = form.hasAttribute('is-express');
    const size = this // should be passed via onItemSizeChange.call(->this<-, this.form)

    // The refusal that is displayed is tied to the size that was submitted
    removeAddToBasketError(form);

    if (is_mobile && isExpress) {
        size.setAttribute('is-processing', '');
    }

    if (size.checked) {
        const id = form.getAttribute('data-product-id');

        btnAddCart.setAttribute('is-processing', '');
        btnAlertStock.setAttribute('is-processing', '');
        form.setAttribute('data-product-size', size.value);
        form.setAttribute('data-product-ean', size.getAttribute('data-ean'));
        btnAddCart.setAttribute('data-product-size', size.value);
        btnAddWishlist.setAttribute('data-itemsize', size.value);
        wrapperAlertStock.setAttribute('data-alert-size', size.value);

        const hasStock = await getAvailableQuantity(form);

        // Check if product in wishlist because we have color and size checked available
        checkProductInWishlist(form.getAttribute('data-product-id'));

        if (is_mobile && isExpress) {
            if (hasStock) {
                addToBasket(form);
            } else {
                mobile_expressAlertStockHandler(null, form);
            }
        }

        if (is_mobile && isExpress) {
            size.removeAttribute('is-processing');
        }
    }

    // Fire a custom event to notify other scripts that size has changed
    const sizeChangedEvent = new CustomEvent('onItemSizeChange_complete', {
        detail: {
            isExpress: isExpress,
            productId: form.getAttribute('data-product-id'),
            sizeId: size.value,
            sizeEan: size.getAttribute('data-ean'),
            form: form,
            btnAddCart: btnAddCart,
            btnAddWishlist: btnAddWishlist,
            btnAlertStock: btnAlertStock,
            wrapperAlertStock: wrapperAlertStock
        }
    });
    document.dispatchEvent(sizeChangedEvent);
}

/* ADD WISHLIST AND CART HANDLERS */
function btnWishlistHandler_withSize(event) {
    event.preventDefault();
    event.stopPropagation();

    addToWishlist(event.currentTarget);
}

async function btnAddCartHandler_withSize(event) {
    event.preventDefault();
    const form = this.closest('form');

    if (!form) {
        console.error('Product form not found for add to cart button');
        return;
    }

    // In MPOS mode, skip the pre-stock check — stock is location-dependent and handled inside addToBasket
    if (typeof isMposV2 !== 'undefined' && isMposV2) {
        addToBasket(form);
        return;
    }

    addToBasket(form);
}

function btnHandler_withoutSize(event) {
    event.preventDefault();
    openModal('size-selector');
}

function btnWishlistHandler_withoutSize(event) {
    let wishlistBtn = event.currentTarget;
    let sizeSelectorModal = document.querySelector('#size-selector');

    if (!sizeSelectorModal) {
        console.error('Size selector modal not found');
        return;
    }

    // Prevent the default, but add listeners to wait for size selection, and then add to wishlist
    event.preventDefault();

    // Listen to the closeModal event to disconnect the events if the modal is closed without selection
    let closeModalNoSizeHandler = function (e) {
        if (e.detail.modalId !== 'size-selector') return;
        document.removeEventListener('closeModal', closeModalNoSizeHandler);
        document.removeEventListener('sizeSelectedFromModal', modalSizeSelectedHandler);
    }
    document.addEventListener('closeModal', closeModalNoSizeHandler);

    // Listen for size selection from the modal
    let modalSizeSelectedHandler = function () {
        document.removeEventListener('sizeSelectedFromModal', modalSizeSelectedHandler);
        document.removeEventListener('closeModal', closeModalNoSizeHandler);

        // Wait for the onItemSizeChange_complete event to ensure size is set
        let onSizeChangeCompleteHandler = function (e) {
            document.removeEventListener('onItemSizeChange_complete', onSizeChangeCompleteHandler);

            // Add to wishlist now that size is selected, via a simulated click on the wishlist button after the data attributes have been set
            setTimeout(() => {
                addToWishlist(wishlistBtn);
            }, 0);
        }
        document.addEventListener('onItemSizeChange_complete', onSizeChangeCompleteHandler);
    }
    document.addEventListener('sizeSelectedFromModal', modalSizeSelectedHandler);

    // Open the size selector modal to prompt user to select a size
    openModal('size-selector');
}

/**
 * Updates the "Add to Cart" button state based on product color and size selection.
 *
 * @param {string} elem - CSS selector for the product container element
 * @returns {void}
 *
 * @description
 * This function:
 * - Validates if color and size attributes are selected
 * - Updates button text with appropriate prompts or translations
 * - Sets product color and size data attributes on buttons
 * - Manages event listeners for add-to-cart and wishlist actions based on selection state
 * - Dispatches a custom 'btnAddCart_updated' event for other scripts to listen to
 *
 * @example
 * updateBtnAddCart('.product-item');
 *
 * @fires btnAddCart_updated - Custom event dispatched with button and selection details
 */
function updateBtnAddCart(elem) {
    const btnAddCart = document.querySelector(elem + ' .product-add-cart-button');
    const btnAddWishlist = document.querySelector(elem + ' .item-wishlist');

    if (!btnAddCart || !btnAddWishlist) {
        return;
    }

    const isColorChecked = document.querySelector(elem + ' input[name="prod_color"]:checked');
    const isSizeChecked = document.querySelector(elem + ' input[name="prod_size"]:checked');
    const addCartText = document.querySelector(elem).hasAttribute('is-express') ? Translator.translate('item_add_cart') : Translator.translate('product_add_cart');

    if (!isColorChecked) {
        btnAddCart.innerHTML = Translator.translate('product_select_color');
    } else {
        btnAddCart.setAttribute('data-product-color', isColorChecked.value);
        btnAddWishlist.setAttribute('data-product-color', isColorChecked.value);
    }

    // Clean all listeners before applying them
    btnAddCart.removeEventListener('click', btnAddCartHandler_withSize);
    btnAddCart.removeEventListener('click', btnHandler_withoutSize);
    btnAddWishlist.removeEventListener('click', btnWishlistHandler_withSize);
    btnAddWishlist.removeEventListener('click', btnWishlistHandler_withoutSize);

    if (!isSizeChecked) {
        btnAddCart.innerHTML = Translator.translate('product_select_size');
        btnAddCart.addEventListener('click', btnHandler_withoutSize);
        btnAddWishlist.addEventListener('click', btnWishlistHandler_withoutSize);
    } else {
        btnAddCart.innerHTML = addCartText + (document.querySelector('[is-sale-price]') ? '<span class="price-reminder">' + document.querySelector('[is-sale-price]').innerHTML + '</span>' : '');
        btnAddWishlist.setAttribute('data-product-size', isSizeChecked.value);
        btnAddCart.addEventListener('click', btnAddCartHandler_withSize);
        btnAddWishlist.addEventListener('click', btnWishlistHandler_withSize);
    }

    // Check stock availability for the selected size and color, and update button text if not available
    let hasAvailableStock = document.querySelector(elem + ' input[name="has-available-stock"]') ? document.querySelector(elem + ' input[name="has-available-stock"]').value === '1' : true;
    if (!hasAvailableStock) {
        btnAddCart.innerHTML = Translator.translate('item_receive_alert');
    }

    // Fire a custom event to notify other scripts that btnAddCart has been updated
    const btnAddCartUpdatedEvent = new CustomEvent('btnAddCart_updated', {
        detail: {
            btnAddCart: btnAddCart,
            btnAddWishlist: btnAddWishlist,
            isColorChecked: isColorChecked,
            isSizeChecked: isSizeChecked
        }
    });
    document.dispatchEvent(btnAddCartUpdatedEvent);
}

/**
 * ajax_upd_panier.php answers a "//" separated string once the line is added, but a JSON
 * payload { "error": { "code": …, "msg": … } } as soon as the server refuses it (no stock
 * left, maximum quantity reached, gift points, …). Splitting that JSON on "//" returns a
 * single element, so the `array_response[1] == "false"` test below never matched: the
 * refusal was swallowed and the success path kept running (SW-22437).
 *
 * @param {string} response Raw body returned by ajax_upd_panier.php
 *
 * @returns {string|null} Message to display, or null when the response is not a refusal
 */
function getAddToBasketError(response) {
    if (typeof response !== 'string' || response.indexOf('"error"') === -1) {
        return null;
    }

    let payload;

    try {
        payload = JSON.parse(response);
    } catch (e) {
        return null;
    }

    if (!payload || !payload.error) {
        return null;
    }

    return payload.error.msg || Translator.translate('error_add_basket');
}

/**
 * Remove the add to cart error message
 *
 * @param {HTMLElement} [form] Form to clean up, defaults to the whole document
 */
function removeAddToBasketError(form) {
    (form || document).querySelectorAll('.add-cart-error-message').forEach(function (elem) {
        elem.remove();
    });
}

/**
 * Display, under the add to cart CTA, the reason why the server refused the line
 *
 * @param {HTMLElement} form Form the customer submitted
 * @param {string} message Message returned by the server
 */
function displayAddToBasketError(form, message) {
    removeAddToBasketError(form);

    const wrapper = form.querySelector('.product-add-cart') || form;
    const elem = document.createElement('p');

    elem.className = 'add-cart-error-message';
    elem.setAttribute('role', 'alert');
    // textContent: the message is built server side, it must never be injected as HTML
    elem.textContent = message;

    wrapper.appendChild(elem);
}

/**
 * Give the customer back a usable page when the server refused the line: stop the loaders,
 * tell them why, and notify the listeners (Unify stock widget, mobile express) with the
 * error event only — the success event used to be dispatched here as well, so the page
 * behaved as if the product had been added.
 *
 * @param {HTMLElement} form Form the customer submitted
 * @param {HTMLElement} btnAddCart Add to cart CTA of that form
 * @param {string} idProduit Id of the product that was refused
 * @param {string} idTaille Id of the size that was refused
 * @param {string} message Message returned by the server
 */
async function handleAddToBasketError(form, btnAddCart, idProduit, idTaille, message) {
    console.error('Add to basket refused by the server:', message);

    btnAddCart?.removeAttribute('is-loading');

    if (typeof isMposV2 !== 'undefined' && isMposV2 && document.body.classList.contains('product_page')) {
        form.querySelector('[slot="add-to-cart-btn"]')?.removeAttribute('is-loading');
    }

    // Re-sync the size and the CTA with the server: the refusal means the state rendered with
    // the page is not the one the basket enforces any more. Skipped in MPOS V2 mode, where the
    // online stock is legitimately 0 for the store only items.
    if (typeof isMposV2 === 'undefined' || !isMposV2) {
        try {
            await getAvailableQuantity(form);
        } catch (error) {
            console.error('Availability refresh failed after a refused add to basket:', error);
        }
    }

    displayAddToBasketError(form, message);

    document.dispatchEvent(new CustomEvent('addToBasket_error', {
        detail: {
            idProduit: idProduit,
            idTaille: idTaille
        }
    }));
}

async function addToBasket(form) {
    // MPOS V2: ensure stock source is selected before proceeding
    if (typeof isMposV2 !== 'undefined' && isMposV2) {
        if (typeof unifyStockCheckHandler !== 'function') {
            console.warn('Supposed to run the MPOS V2 check but unifyStockCheckHandler is not defined - moving on.');
        } else {
            try {
                const formToUse = await unifyStockCheckHandler({ form });
                if (!formToUse) {
                    if (is_mobile && form.hasAttribute('is-express') && typeof closeSizeSelector === 'function') {
                        closeSizeSelector();
                    }
                    return;
                }
                form = formToUse;
            } catch (error) {
                console.error('Error in unifyStockCheckHandler:', error);
                return;
            }
        }
    }

    const prixU = form.getAttribute('data-prixU');
    const idProduit = form.getAttribute('data-product-id');
    const idCouleur = form.getAttribute('data-product-color');
    const idTaille = form.getAttribute('data-product-size');
    const paniervirtuelId = form.getAttribute('data-panier-id');
    const isExpress = form.hasAttribute('is-express');
    // '' not null: null interpolated in the URL template string below becomes the literal text "null"
    const stockLocation = form.hasAttribute('data-stock-location') ? form.getAttribute('data-stock-location') : '';
    const isReferrenceRegroupment = form.hasAttribute('is-regroup-ref');
    const counter = form.getAttribute('data-cpt') ? form.getAttribute('data-cpt') : null;
    let addSelectorbtnAddCart = '';
    if (isExpress && isReferrenceRegroupment) {
        addSelectorbtnAddCart = '_' + counter;
    }
    const btnAddCart = document.querySelector('#prod_info_' + idProduit + addSelectorbtnAddCart + ' .product-add-cart-button');
    btnAddCart?.setAttribute('is-loading', '');

    let i = btnAddCart.getAttribute('data-suff');
    if (i != "") {
        i = "_" + i;
    }

    if (document.getElementById("qteProd" + i) && document.getElementById("qteProd" + i).value == "") {
        res = ajax_file(path_web + "ajax_sprintf.php?arg1=js_error_quantity");
        flagError = true;
        alert(res);
        btnAddCart.removeAttribute('is-loading');
    } else {
        var qte = 1;
        let serverError = null;

        let url = `${path_relative_root}ajax_upd_panier.php?prixu=${prixU}&idprod=${idProduit}&idcouleur=${idCouleur}&idtaille=${idTaille}&qte=${qte}&panierId=${paniervirtuelId}&stockLocation=${stockLocation}`;

        fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        })
        .then(response => response.text())
        .then(response => {
            serverError = getAddToBasketError(response);

            if (serverError) {
                // Nothing was added: drop the payload of the previous call so that the
                // dataLayer push done in the finally block cannot replay it
                array_response = [];

                return false;
            }

            removeAddToBasketError(form);

            array_response = response.split("//");
            // No stock left
            if (array_response[1] == "false") {
                document.getElementById("prod_size_" + idProduit + '_' + idTaille).nextElementSibling.setAttribute('no-stock', '');

                const addedToBasketEvent = new CustomEvent('addToBasket_error', {
                    detail: {
                        idProduit: idProduit,
                        idTaille: idTaille
                    }
                });
                document.dispatchEvent(addedToBasketEvent);

                return false;
            }
        })
        .finally(async () => {
            // The server refused the line: stop here, nothing was added to the basket
            if (serverError) {
                await handleAddToBasketError(form, btnAddCart, idProduit, idTaille, serverError);

                return;
            }

            // Check stock availability
            // In MPOS V2 mode, skip the post-add stock check — online stock may be 0 for store-only items,
            // which would cause addToBasket_error to fire and prevent the dialog from closing.
            const hasStock = (typeof isMposV2 !== 'undefined' && isMposV2) ? true : await getAvailableQuantity(form);

            // Loading is done
            setTimeout(function () {
                btnAddCart.removeAttribute('is-loading');

                // Check if we're in MPOS V2 mode, and on a product page
                if (typeof isMposV2 !== 'undefined' && isMposV2 && document.body.classList.contains('product_page')) {
                    // In MPOS V2 mode, we also want the button inside the Unify Stock Widget slot to stop loading
                    form.querySelector('[slot="add-to-cart-btn"]').removeAttribute('is-loading');
                }
            }, 0);

            // If getAvailableQuantity returns false here, it means that when adding to basket, this was the last stock available
            if (!hasStock) {
                console.error('No stock available after adding to basket');

                // Display alert stock form
                if (window.wShop && wShop.$refs && wShop.$refs.wAlertestockForm) {
                    wShop.$refs.wAlertestockForm.reloadBloc += 1;
                }

                // Throw custom event
                const addToBasketErrorEvent = new CustomEvent('addToBasket_error', {
                    detail: {
                        idProduit: idProduit,
                        idTaille: idTaille
                    }
                });
                document.dispatchEvent(addToBasketErrorEvent);
            }

            // Throw custom event
            const addedToBasketEvent = new CustomEvent('addToBasket_success', {
                detail: {
                    idProduit: idProduit,
                    idTaille: idTaille
                }
            });
            document.dispatchEvent(addedToBasketEvent);

            if (array_response.length >= 0 && array_response[6] !== undefined) {
                var dlv3_objet = JSON.parse(array_response[6]);
                try {
                    DataLayerTrigger.addToCart(dlv3_objet['items'], dlv3_objet['actionField'], '');
                } catch (e) {
                    console.error('Error pushing to dataLayer_v3', e);
                }
            }
            // Update top cart
            fetch(path_relative_root + 'ajax_show_basket.php', {
                method: 'GET',
                credentials: 'same-origin'
            })
            .then(response => response.text())
            .then(response_basket => {
                if (is_mobile) {
                    if (isExpress) {
                        if (document.querySelector('.item-sizes[is-displayed]')) document.querySelector('.item-sizes[is-displayed]').removeAttribute('is-displayed');
                        if (!document.querySelector("#prod_size_" + idProduit + '_' + idTaille).closest('.item-product').hasAttribute('is-unique-size')) document.querySelector("#prod_size_" + idProduit + '_' + idTaille).checked = false; // Do not uncheck size if unique size product
                        document.querySelector("#prod_size_" + idProduit + '_' + idTaille).removeAttribute('is-processing');
                    }

                    // Display purchase confirmation on mobile
                    displayPurchaseConfirmation();
                }

                // Update header cart
                document.querySelector('.top-cart').innerHTML = response_basket;

                // Display header cart on desktop
                if (!is_mobile) {
                    setTimeout(function () {
                        displayCartTop();
                    }, 0);
                }

            });
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
}

function displayPurchaseConfirmation() {
    const confirmation_block = document.querySelector('.purchase-confirmation');

    if (confirmation_block) {
        // Hide look pin modal if open
        let lookModals = document.querySelectorAll('.look-modal');
        if (lookModals.length > 0) {
            lookModals.forEach(modal => {
                if (modal.hasAttribute('modal-open')) {
                    modal.removeAttribute('modal-open');
                }
            });
        }

        confirmation_block.setAttribute('is-displayed', '');
        toggleBackdrop(1);
        document.body.style.overflow = "hidden";

        const confirmationCrossSellSlider = document.querySelector('.confirmation-cross-sell-slider');

        // Load product sliders inside the modal
        setTimeout(function () {
            loadItemSliders();
        }, 300);

        const swiper = new Swiper(confirmationCrossSellSlider, {
            slidesPerView: 'auto',
            spaceBetween: 12,
        });

        document.querySelector('.modal-backdrop').addEventListener('click', function () {
            hidePurchaseConfirmation();
        });
    }
}

function hidePurchaseConfirmation() {
    const confirmation_block = document.querySelector('.purchase-confirmation');

    if (confirmation_block) {
        confirmation_block.removeAttribute('is-displayed', '');
        toggleBackdrop(0);
        document.body.style.overflow = "";

        document.querySelector('#buyTogetherSliderMobile')?.classList.remove('is-displayed-actif');

        const wrapper = document.querySelector('#buyTogetherSliderMobile > .swiper-wrapper');

        if (wrapper) {
            wrapper.style.marginLeft = '';
        }
    }
}

function ajax_RemoveBasketProd(basket_id, prod_id, qte) {
    document.querySelector('.rollover-basket-product[data-product-id="' + prod_id + '"][data-basket-id="' + basket_id + '"]').setAttribute('is-processing', '');

    const data = {
        basket_id: basket_id,
        prod_id: prod_id,
        qte: qte,
        is_service: typeof isService !== 'undefined' ? isService : undefined
    };

    fetch(path_relative_root + 'ajax_removeBasketProd.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
    })
    .then(response => response.text())
    .then(res => {
        let json;
        try {
            json = JSON.parse(res);
        } catch (e) {
            console.error('parseJSON');
            return;
        }

        document.querySelector('.top-cart').innerHTML = json.datas.html;

        // In case same product in wishlist rollover
        if (document.querySelector('.rollover-basket-product[data-product-id="' + prod_id + '"]')) {
            document.querySelector('.rollover-basket-product[data-product-id="' + prod_id + '"]').removeAttribute('is-processing');
        }

        if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && prod_id !== null && prod_id !== undefined) {
            DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, prod_id, "remove_from_cart", qte);
        }
    });
}

function reloadFromAlertStock(id = null) {
    let btnAddCart, blocAlertStock, btnAlertStock, checkedSize, isExpress, isUniqueSize, formAlertStock;

    if (id != null) {
        let product, product_quickActions;

        blocAlertStock = document.querySelector('#bloc_add_alert_' + id);
        blocAlertStock.setAttribute('is-hidden', '');
        btnAlertStock = document.querySelector('#prod_info_' + id + ' .product-add-alert-button');
        btnAddCart = document.querySelector('#prod_info_' + id + ' .product-add-cart-button');
        checkedSize = document.querySelector('#prod_info_' + id + ' input[name="prod_size"]:checked');
        isUniqueSize = document.querySelector('#prod_info_' + id).hasAttribute('is-unique-size');
        formAlertStock = document.querySelector('#prod_info_' + id + ' .alert-stock-wrapper');
        isExpress = document.querySelector('#prod_info_' + id).hasAttribute('is-express');
        product = document.querySelector('#prod_info_' + id).closest('.item-product') ? document.querySelector('#prod_info_' + id).closest('.item-product') : false;
        product_quickActions = product ? product.querySelector('.mobile-interaction-sizes') : false;
    } else {
        btnAddCart = document.querySelector('.product-add-cart-button');
        blocAlertStock = document.querySelector('#bloc_add_alert');
        checkedSize = document.querySelector('input[name="prod_size"]:checked');
        isUniqueSize = document.querySelector('.product-infos-form').hasAttribute('is-unique-size');
        formAlertStock = document.querySelector('.alert-stock-wrapper');
        isExpress = false;
    }

    // Remove the loader from the btnAlertStock
    if (btnAlertStock) {
        btnAlertStock.removeAttribute('is-processing');
        btnAlertStock.removeAttribute('is-loading');
    }

    // Uncheck size if not unique size product
    if (checkedSize && !isUniqueSize) {
        checkedSize.checked = false;
        btnAddCart.removeAttribute('is-hidden');
        blocAlertStock.setAttribute('is-hidden', '');

        setTimeout(function () {
            if (id != null) {
                // List page or ID passed
                updateBtnAddCart('#prod_info_' + id);
            } else {
                // FP
                updateBtnAddCart('.product-infos-form');
            }
        }, 0);
    }

    // List page case, show back the add alert btn if is unique size product
    if (checkedSize && isUniqueSize && isExpress) {
        btnAlertStock.removeAttribute('is-hidden');
    }

    // Close backdrop and remove loading state on mobile express add to basket
    if (is_mobile && isExpress) {
        if (formAlertStock.offsetParent !== null) {
            toggleBackdrop(0);
            if (product_quickActions) product_quickActions.removeAttribute('is-loading');
        }
    }

    const reloadAlertStockEvent = new CustomEvent('reloadAlertStock_end');
    document.dispatchEvent(reloadAlertStockEvent);
}

function reloadExpressAlertStock(id) {
    const blocAlertStock = document.querySelector('#bloc_add_alert_' + id);

    blocAlertStock.setAttribute('is-hidden', '');
}

function reloadAccountAlertStock(id) {
    const blocAlertStock = document.querySelector('#bloc_add_alert_' + id);

    blocAlertStock.setAttribute('is-hidden', '');
    document.querySelector('.wishlist-receive-alert[data-prod-id="' + id + '"]').remove();
}

function displayCartTop() {
    const header = document.querySelector('header');
    const cartTop = document.querySelector('.top-cart');
    if (cartTop) {
        // Hide look pin modal if open
        const lookModals = document.querySelectorAll('.look-modal');
        if (lookModals.length > 0) {
            lookModals.forEach(modal => {
                if (modal.hasAttribute('modal-open')) {
                    modal.removeAttribute('modal-open');
                }
            });
        }

        header.setAttribute('has-rollover', '');
        cartTop.setAttribute('is-displayed', '');
        toggleBackdrop(1);

        setTimeout(function () {
            header.removeAttribute('has-rollover');
            cartTop.removeAttribute('is-displayed');
            toggleBackdrop(0);
        }, 2000);
    }
}

/* Alert stock handler */
document.addEventListener('click', function (event) {
    if (event.target.matches('.item-add-alert-button')) {
        event.target.setAttribute('is-hidden', '');
        event.target.nextElementSibling.removeAttribute('is-hidden');
    }
});

function mobile_expressAlertStockHandler(btn = null, form) {
    const alertStockBtn = form.querySelector('.item-add-alert-button');
    const alertStockForm = form.querySelector('.alert-stock-wrapper');
    const itemSizes = form.closest('.item-product').querySelector('.item-sizes');

    if (form.hasAttribute('is-express')) {
        if (itemSizes.hasAttribute('is-displayed')) {
            itemSizes.removeAttribute('is-displayed');

            // Slightly delay the click to allow sizes to close properly
            setTimeout(() => alertStockBtn.click(), 300);
        } else {
            // Mobile design is directly the form so click on its associated alert stock button to display it
            alertStockBtn.click();
        }

        // Add backdrop only if no one is appearing (if sizes are visible, backdrop is already visible)
        if (!itemSizes.hasAttribute('is-displayed')) {
            toggleBackdrop(1);
        }

        // Close alert stock
        document.querySelector('.modal-backdrop').addEventListener('click', function () {
            const el = form.querySelector('.alert-stock-wrapper')
            const isVisible = el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
            if (isVisible) {
                reloadFromAlertStock(form.getAttribute('data-product-id'));
            }
        });

        // Remove loading state on button when alert stock form is reloaded via reloadFromAlertStock function
        document.addEventListener('reloadAlertStock_end', function () {
            toggleBackdrop(0);
            if (btn !== null) {
                btn.removeAttribute('is-loading');
            }

            if (document.body.style.overflow == "hidden") {
                document.body.style.overflow = "";
            }
        });
    }
}

function addToCart(rank) {

    if (typeof productFieldObject !== 'undefined' && productFieldObject !== '') {
        var product = productFieldObject[rank];
        product.quantity = 1;

        if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && product.id !== null && product.id !== undefined) {
            DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, product.id, "add_to_cart", product.quantity);
        }

        var new_dataLayer = dataLayer[1];

        if (new_dataLayer !== null && new_dataLayer !== undefined && (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '1')) {
            new_dataLayer.ecommerce.checkout.products[rank].quantity = parseFloat(document.getElementsByClassName('selected_qte')[rank].value) + 1;
            pushToWshopBus(new_dataLayer);
            dataLayer[1] = new_dataLayer;
        }
    }
}
